"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataStore = (function () {
    function DataStore(json) {
        this.json = json;
    }
    DataStore.prototype.getAllStates = function () {
        var states = this.json.states;
        return states.map(function (s) {
            return { value: s.name, name: s.name };
        });
    };
    DataStore.prototype.getAdvisorsArray = function (campusName) {
        var json = this.json;
        if (json.campuses) {
            for (var i = 0; i < json.campuses.length; i++) {
                if (json.campuses[i].name == campusName) {
                    return json.campuses[i].advisors;
                }
            }
        }
        console.log("Warning! No advisers found for campus=" + campusName);
        return null;
    };
    Object.defineProperty(DataStore.prototype, "programs", {
        get: function () {
            var json = this.json;
            var programs = [];
            if (json.programs) {
                programs = json.programs;
                programs.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
            return programs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "campuses", {
        get: function () {
            var json = this.json;
            var campuses = [];
            if (json.campuses) {
                campuses = json.campuses;
                campuses.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
            return campuses;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "marital_status", {
        get: function () {
            return [
                { value: "Married", name: "Married" },
                { value: "Single", name: "Single" },
                { value: "Divorced", name: "Divorced" },
                { value: "Widow", name: "Widow" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "gender", {
        get: function () {
            return [
                { value: "Male", name: "Male" },
                { value: "Female", name: "Female" },
                { value: "Other", name: "Non-Binary" },
                { value: "None", name: "Prefer Not To Disclose" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "schedules", {
        get: function () {
            return [
                { name: "Part time schedule", value: "Part time schedule" },
                { name: "Full time schedule", value: "Full time schedule" },
                { name: "Night time schedule", value: "Night time schedule" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "year", {
        get: function () {
            return [
                { value: "January", name: "January" },
                { value: "February", name: "February" },
                { value: "March", name: "March" },
                { value: "April", name: "April" },
                { value: "May", name: "May" },
                { value: "June", name: "June" },
                { value: "July", name: "July" },
                { value: "August", name: "August" },
                { value: "September", name: "September" },
                { value: "October", name: "October" },
                { value: "November", name: "November" },
                { value: "December", name: "December" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "asher_course", {
        get: function () {
            return [
                { value: "Hair Design", name: "H = Hair Design" },
                { value: "Esthetics", name: "F = Esthetics" },
                { value: "Nail Technology", name: "N = Nail Technology" },
                { value: "Barbering", name: "R = Barbering" },
                { value: "Esthetics & Nail", name: "FN = Esthetics & Nail" },
                { value: "Hair, Esthetics & Nail", name: "HFN = Hair, Esthetics & Nail" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "collegeType", {
        get: function () {
            return [
                { value: "Some College", name: "Some College" },
                { value: "Associate Degree", name: "Associate Degree" },
                { value: "Bachelor", name: "Bachelor" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "educationList", {
        get: function () {
            return [
                { value: "high-school", name: "High School Diploma" },
                { value: "ged", name: "G.E.D." },
                { value: "high-school-international", name: "High School International" },
                { value: "home-school", name: "Homeschool" },
                { value: "other", name: "Other" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "enrollmentStatus", {
        get: function () {
            return [
                { value: "full_time", name: "Full Time" },
                { value: "half_time", name: "Part Time" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "degreeLevel", {
        get: function () {
            return [
                { value: "Some College", name: "Some College" },
                { value: "Certificate", name: "Certificate" },
                { value: "Associate", name: "Associate" },
                { value: "Undergraduate", name: "Undergraduate" },
                { value: "Post Undergraduate", name: "Post Undergraduate" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "educationGoals", {
        get: function () {
            return [
                { value: "Diploma", name: "Diploma" },
                { value: "Certification", name: "Certification" },
                { value: "Associate Degree", name: "Associate Degree" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "militaryBranch", {
        get: function () {
            return [
                { value: "air_force", name: "Air Force" },
                { value: "air_force_reserve", name: "Air Force Reserve" },
                { value: "air_national_guard", name: "Air Force Guard" },
                { value: "army", name: "Army" },
                { value: "army_national_guard", name: "Army National Guard" },
                { value: "army_reserve", name: "Army Reserve" },
                { value: "coast_guard", name: "Coast Guard" },
                { value: "coast_guard_reserve", name: "Coast Guard Reserve" },
                { value: "marine_corps", name: "Marine Corps" },
                { value: "marine_corps_reserve", name: "Marine Corps Reserve" },
                { value: "navy", name: "Navy" },
                { value: "navy_reserve", name: "Navy Reserve" },
                { value: "space_force", name: "Space Force" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "militaryStatus", {
        get: function () {
            return [
                { value: "not_veteran", name: "Not a Veteran" },
                { value: "veteran", name: "Veteran" },
                { value: "active_duty", name: "Veteran Active" },
                { value: "spouse", name: "Veteran Spouse" },
                { value: "child_dependent", name: "Veteran Dependent" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "hoursPerWeek", {
        get: function () {
            return [
                { value: "20 hours per week", name: "20 hours per week" },
                { value: "25 hours per week", name: "25 hours per week" },
                { value: "30 hours per week", name: "30 hours per week" },
                { value: "35 hours per week", name: "35 hours per week" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "scaleOneToTen", {
        get: function () {
            return [
                { value: "1", name: "1" },
                { value: "2", name: "2" },
                { value: "3", name: "3" },
                { value: "4", name: "4" },
                { value: "5", name: "5" },
                { value: "6", name: "6" },
                { value: "7", name: "7" },
                { value: "8", name: "8" },
                { value: "9", name: "9" },
                { value: "10", name: "10" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "whatAreYouLookingInCollege", {
        get: function () {
            return [
                { value: "Affordability", name: "Affordability" },
                { value: "Flexible class schedule", name: "Flexible class schedule" },
                { value: "Hands on", name: "Hands on" },
                { value: "Ability to earn Certifications", name: "Ability to earn Certifications" },
                { value: "Ability to earn a degree", name: "Ability to earn a degree" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "pursueEducation", {
        get: function () {
            return [
                { value: "Make more money", name: "Make more money" },
                { value: "A career I enjoy", name: "A career I enjoy" },
                { value: "Following my passion", name: "Following my passion" },
                { value: " Make my family proud", name: " Make my family proud" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "whatAreYouLookingInCollegeCheckboxList", {
        get: function () {
            return [
                { id: 1, value: "Affordability", name: "Affordability", checked: false },
                {
                    id: 2,
                    value: "Flexible class schedule",
                    name: "Flexible class schedule",
                    checked: false
                },
                { id: 3, value: "Hands on", name: "Hands on", checked: false },
                {
                    id: 4,
                    value: "Ability to earn Certifications",
                    name: "Ability to earn Certifications",
                    checked: false
                },
                {
                    id: 5,
                    value: "Ability to earn a degree",
                    name: "Ability to earn a degree",
                    checked: false
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "pursueEducationCheckboxList", {
        get: function () {
            return [
                { id: 1, value: "Make more money", name: "Make more money", checked: false },
                { id: 2, value: "A career I enjoy", name: "A career I enjoy", checked: false },
                { id: 3, value: "Following my passion", name: "Following my passion", checked: false },
                { id: 4, value: "Make my family proud", name: " Make my family proud", checked: false }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "backgroundChallenge", {
        get: function () {
            return [
                { value: "Challenge No", name: "No" },
                { value: "Yes, Misdemeanor", name: "Yes, Misdemeanor" },
                { value: "Yes, Felony", name: "Yes, Felony" },
                { value: "Yes, Other", name: "Yes, Other" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "schoolMostAskedQuestionsList", {
        get: function () {
            return [
                { id: 1, value: "Transportation", name: "Cost/Affordability", checked: false },
                { id: 2, value: "Work", name: "Class Schedule", checked: false },
                { id: 3, value: "Class Schedule", name: "What do I get?", checked: false },
                { id: 4, value: "Fear", name: "Job placement assistance", checked: false }
            ];
        },
        enumerable: true,
        configurable: true
    });
    DataStore.prototype.getAllCountries = function () {
        var countries = this.json.countries;
        return countries.map(function (s) {
            return { value: s.name, name: s.name };
        });
    };
    return DataStore;
}());
exports.DataStore = DataStore;
//# sourceMappingURL=data:application/json;base64,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